import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Patch ResizeObserver early to avoid console warnings and reduce loops caused
// by synchronous ResizeObserver callbacks in third-party code.
import './patches/patchResizeObserver';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
